package com.evoapps.evoshift.domain.staffimport

/**
 * The downloadable CSV template (a convenience: any spreadsheet works through the mapping). Its
 * headers map to every field automatically; two fictional example rows show the values. Semicolon
 * separated with a UTF-8 byte order mark, so Excel opens it with Polish letters intact. The same
 * files are in the help centre (docs/user/files, kept equal by StaffImportTemplateTest).
 */
object StaffImportTemplate {

    /** The template in [language] ("pl", "en", "uk"; anything else: English). */
    fun csv(language: String): String {
        val (headers, rows) = when (language) {
            "pl" -> PL
            "uk" -> UK
            else -> EN
        }
        return "﻿" + (listOf(headers) + rows).joinToString("\r\n", postfix = "\r\n") { it.joinToString(";") }
    }

    fun fileName(language: String): String = when (language) {
        "pl" -> "evoshift-pracownicy-szablon.csv"
        "uk" -> "evoshift-pratsivnyky-shablon.csv"
        else -> "evoshift-employees-template.csv"
    }

    /** The columns in the order the template has them. */
    val FIELDS: List<StaffImportField> = listOf(
        StaffImportField.NAME, StaffImportField.EMAIL, StaffImportField.PHONE, StaffImportField.ROLE,
        StaffImportField.PERMISSION, StaffImportField.CONTRACT, StaffImportField.PAY_MODEL, StaffImportField.RATE,
        StaffImportField.STUDENT, StaffImportField.SHIFT_LEAD
    )

    private val PL = listOf(
        "Imię i nazwisko", "E-mail", "Telefon", "Stanowisko", "Uprawnienia", "Rodzaj umowy", "Forma wynagrodzenia", "Stawka", "Student", "Kierownik zmiany"
    ) to listOf(
        listOf("Jan Kowalski", "jan.kowalski@example.com", "600 100 200", "Barista", "Pracownik", "Umowa zlecenie", "Godzinowa", "31,50", "Tak", "Nie"),
        listOf("Anna Nowak", "anna.nowak@example.com", "+48 601 200 300", "Barista", "Kierownik", "Umowa o pracę", "Miesięczna", "6500", "Nie", "Tak")
    )

    private val EN = listOf(
        "Name", "Email", "Phone", "Role", "Permission", "Contract type", "Pay model", "Rate", "Student", "Shift lead"
    ) to listOf(
        listOf("Jan Kowalski", "jan.kowalski@example.com", "600 100 200", "Barista", "Employee", "Civil law contract", "Hourly", "31.50", "Yes", "No"),
        listOf("Anna Nowak", "anna.nowak@example.com", "+48 601 200 300", "Barista", "Manager", "Employment contract", "Monthly", "6500", "No", "Yes")
    )

    private val UK = listOf(
        "Ім'я та прізвище", "Електронна адреса", "Телефон", "Посада", "Права доступу", "Тип договору", "Форма оплати", "Ставка", "Студент", "Старший зміни"
    ) to listOf(
        listOf("Jan Kowalski", "jan.kowalski@example.com", "600 100 200", "Бариста", "Працівник", "Договір доручення (umowa zlecenie)", "Погодинна", "31,50", "Так", "Ні"),
        listOf("Anna Nowak", "anna.nowak@example.com", "+48 601 200 300", "Бариста", "Керівник", "Трудовий договір (umowa o pracę)", "Щомісячна", "6500", "Ні", "Так")
    )
}
